import { Button, Card } from "antd";
import React, { useState } from "react";
import LogoBackground from "assets/images/diary-bg-img.jpg";
import Logo from "assets/images/logo.svg";
import { useSelector } from "react-redux";
import { globalSettings } from "redux/settings/settingSlice";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { useLocation } from "react-router-dom";
import { downloadEvent } from "utilities/generalUtility";
import User from "models/user/user";

export default function SubInfo() {
  const settings = useSelector(globalSettings);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const getCheckoutUrl = async () => {
    try {
      setLoading(true);
      const params = `?diaryId=${queryParams.get(
        "diaryId"
      )}&diaryTopicId=${queryParams.get("diaryTopicId")}`;
      const body = {
        successUrl: `${process.env.REACT_APP_BASE_URL}journal-request${
          queryParams.get("diaryId") ? params : ""
        }`,
        cancelUrl: `${process.env.REACT_APP_BASE_URL}sub-info${
          queryParams.get("diaryId") ? params : ""
        }`,
      };
      const res = await NetworkCall.fetch(
        Request.createCheckoutSession(body),
        false
      );
      downloadEvent("StartTrial");
      window.location.href = res?.data?.url;
      setLoading(false);
    } catch (error) {}
  };

  const backtoLogin = () => {
    User.logoutCall();
  };
  return (
    <React.Fragment>
      <div className="login-container d-flex">
        <div className="login-bg w-100">
          <img className="login-img w-100 h-100" src={LogoBackground} alt="" />
        </div>

        <Card bordered={false} className="login-card sub-info-card">
          <div className="authentication-logo text-center">
            <img className="logo" src={Logo} alt="" />
          </div>
          <h3>Subscription Information</h3>

          <>
            <p>
              ResolveIt.ai offers you {settings?.NumberOfSubscriptionTrialDays}
              -day free trial. Upon completion of the trial period, a $
              {settings?.RecurringSubscriptionAmount} subscription plan purchase
              will be required.
            </p>
            <div className="sub-info-btn">
              <Button
                block
                size="large"
                type="primary"
                onClick={getCheckoutUrl}
                loading={loading}
              >
                Start Trial
              </Button>
            </div>
            <div className="sub-info-btn">
              <Button block size="large" type="ghost" onClick={backtoLogin}>
                Go Back
              </Button>
            </div>
          </>
        </Card>
      </div>
    </React.Fragment>
  );
}
